export default "__VITE_ASSET__4e9591fc__"